/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePsOrderPositionRequest } from '../../models/update-ps-order-position-request';

export interface ApiParkingSpotUpdateParkingSpotsOrderPositionPost$Params {
  parkingPlaceId?: number;
      body?: Array<UpdatePsOrderPositionRequest>
}

export function apiParkingSpotUpdateParkingSpotsOrderPositionPost(http: HttpClient, rootUrl: string, params?: ApiParkingSpotUpdateParkingSpotsOrderPositionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiParkingSpotUpdateParkingSpotsOrderPositionPost.PATH, 'post');
  if (params) {
    rb.query('parkingPlaceId', params.parkingPlaceId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiParkingSpotUpdateParkingSpotsOrderPositionPost.PATH = '/api/ParkingSpot/UpdateParkingSpotsOrderPosition';
